export default "__VITE_ASSET__BOdtjW0$__"